import * as support from "./ProgramStatusReason.support";
import AddIcon from "@mui/icons-material/Add";
import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import Disabled from "components/common/Disabled";
import * as labels from "config.labels";
import * as staticDataService from "services/staticDataService";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const ProgramStatusReason = ({ status, value, onChange }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { data: statusLabels, isLoading } = staticDataService.useConfigQuery(
    "layer_status_labels_v2"
  );

  if (!support.isReasonShown(statusLabels, status, value)) {
    return null;
  }

  const reasons = support.reasonsForStatus(statusLabels, status);
  const selected =
    value == null ? null : support.reasonDisplayName(reasons, value);
  return (
    <Disabled ifReadOnly>
      <Autocomplete
        options={support.reasonOptions(reasons, selected)}
        value={selected}
        disabled={isLoading}
        filterOptions={(choices, state) =>
          support.filterReasonOptions(choices, state?.inputValue)
        }
        getOptionLabel={(option) =>
          option?.addNew ? `Add New: ${option.value}` : option ?? ""
        }
        renderOption={(props, option) => (
          <Box
            component={"li"}
            {...props}
            key={option?.addNew ? "__add_new__" : option}
          >
            {option?.addNew ? (
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <AddIcon fontSize={"small"} />
                <Typography>{`Add New: ${option.value}`}</Typography>
              </Stack>
            ) : (
              <Typography>{option}</Typography>
            )}
          </Box>
        )}
        onChange={(_, choice, reason) => {
          if (reason === "clear" || choice == null) {
            onChange(null);
          } else if (choice?.addNew) {
            onChange(support.reasonValue(reasons, choice.value));
          } else {
            onChange(support.reasonValue(reasons, choice));
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant={"filled"}
            label={translateLabel(labels.PROGRAM_STATUS_REASON_LABEL, {
              default: "Decline/NTU Reason",
            })}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        )}
      />
    </Disabled>
  );
};

export default ProgramStatusReason;
